// extracted by mini-css-extract-plugin
module.exports = {"logos":"Logos_logos__38r5Z","col":"Logos_col___lqdG","dark":"Logos_dark__2ICMD"};